import Servico from './Servico'

class CidServico extends Servico {
  constructor() {
    super('cid')
  }
}

export default CidServico
